<chat-message class="bubble">
  <ng-template #textContent>
    <div class="text">{{ text() }}</div>

    <span class="time">{{ time() | messageDate }}</span>
  </ng-template>
</chat-message>
